import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BusinessTransactionWorkQueueDetailModel } from '../../../shared/models/business-transaction/business-transaction-work-queue-detail-model';
import { WIPStatusType } from '../../../wip/models/enums/w-i-p-status-type.enum';
import { AssignmentDropdown } from '../transaction-queue.component';

@Component({
    selector: 'select-assignment',
    templateUrl: './select-assignment.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectAssignmentComponent implements OnInit, OnDestroy {
    @Input() businessTransaction: BusinessTransactionWorkQueueDetailModel;
    @Input() canManageWorkQueue: boolean;
    @Input() masterDropdownList: any[];
    @Input() userName: string;
    @Output() onAssignDropDown = new EventEmitter<AssignmentDropdown>();

    public dropdownList: any[] = [];
    public hasFocus = false;
    public openedIndex: any;
    public showDisabled: boolean;
    private wipStatuses: WIPStatusType = new WIPStatusType();

    constructor() {}

    ngOnInit() {
        this.setShowDisabled(this.businessTransaction, this.canManageWorkQueue, this.userName);
    }

    ngOnDestroy() {
        this.clearDropdown();
    }

    public handleAssignmentDropdownOperation(businessTransaction: BusinessTransactionWorkQueueDetailModel, recipientUserLoginId: number) {
        const dropdownSelection: AssignmentDropdown = {
            businessTransaction: businessTransaction,
            recipientUserLoginId: recipientUserLoginId
        };
        this.onAssignDropDown.emit(dropdownSelection);
    }

    public onFocus() {
        this.populateDropdown();
        this.hasFocus = true;
    }

    public onFocusOut() {
        this.clearDropdown();
        this.hasFocus = false;
    }

    private clearDropdown() {
        this.dropdownList.length = 0;
    }

    private populateDropdown() {
        if (this.masterDropdownList) {
            this.dropdownList = this.masterDropdownList.slice(0);
        }
    }

    private setShowDisabled(transaction: BusinessTransactionWorkQueueDetailModel, canManageWorkQueue: boolean,
        userName: string) {
        if (transaction) {
            this.showDisabled = (!canManageWorkQueue && transaction.assignedTo != userName) ||
                this.statusTypeNotAllowed(transaction.statusTypeId);
        }
    }

    private statusTypeNotAllowed(statusType: number, wipStatuses: WIPStatusType = this.wipStatuses): boolean {
        return statusType !== wipStatuses.Active.id && statusType !== wipStatuses.Inactive.id;
    }
}
